import { defineMessages } from 'react-intl-next';

// TODO: Improve this, they should be defined in an errorFallbackUI specific to their implementation
// https://hello.jira.atlassian.cloud/browse/NAVX-2886
export const defaultMessages = defineMessages({
	header: {
		id: 'navigation.error.header.default.non-final',
		defaultMessage: 'We couldn’t load this content',
		description: 'Header when an unknown error occurs',
	},
	description: {
		id: 'navigation.error.description.default.non-final',
		defaultMessage: 'Refresh the page and try again',
		description: 'Description when an unknown error occurs',
	},
});

export const customizationMessages = defineMessages({
	header: {
		id: 'navigation.error.header.customization-modal.non-final',
		defaultMessage: 'We couldn’t load your customization options',
		description: 'Header when an unknown error occurs',
	},
	description: {
		id: 'navigation.error.description.customization-modal.non-final',
		defaultMessage: 'Refresh the page and try again',
		description: 'Description when an unknown error occurs',
	},
});

export const shortcutsMessages = defineMessages({
	header: {
		id: 'navigation.error.header.global-shortcuts.non-final',
		defaultMessage: 'We couldn’t load the app',
		description: 'Header when an unknown error occurs',
	},
	description: {
		id: 'navigation.error.description.global-shortcuts.non-final',
		defaultMessage: 'Refresh the page and try again',
		description: 'Description when an unknown error occurs',
	},
});

export const moreMenuMessages = defineMessages({
	header: {
		id: 'navigation.error.header.global-more-menu.non-final',
		defaultMessage: 'We couldn’t load more options',
		description: 'Header when an unknown error occurs',
	},
	description: {
		id: 'navigation.error.description.global-more-menu.non-final',
		defaultMessage: 'Refresh the page and try again',
		description: 'Description when an unknown error occurs',
	},
});

export const sideNavMessages = defineMessages({
	header: {
		id: 'navigation.error.header.global-side-navigation.non-final',
		defaultMessage: 'We couldn’t load the sidebar',
		description: 'Header when an unknown error occurs',
	},
	description: {
		id: 'navigation.error.description.global-side-navigation.non-final',
		defaultMessage: 'Refresh the page and try again',
		description: 'Description when an unknown error occurs',
	},
});

export const sideNavItemActionsMenuMessages = defineMessages({
	header: {
		id: 'navigation.error.header.global-side-navigation-nav-item-actions.non-final',
		defaultMessage: 'We couldn’t load more actions',
		description: 'Header when an unknown error occurs',
	},
	description: {
		id: 'navigation.error.description.global-side-navigation-nav-item-actions.non-final',
		defaultMessage: 'Refresh the page and try again',
		description: 'Description when an unknown error occurs',
	},
});

export const dndMessages = defineMessages({
	header: {
		id: 'navigation.error.ui.header.drag-and-drop.non-final',
		defaultMessage: 'We couldn’t complete this action',
		description: 'Header when an unknown error occurs',
	},
	description: {
		id: 'navigation.error.ui.description.drag-and-drop.non-final',
		defaultMessage: 'Refresh the page and try again',
		description: 'Description when an unknown error occurs',
	},
});
